export function removeFalsey<T>(
  arr: (T | undefined | null)[] | undefined | null
): T[] {
  return (arr ?? []).flatMap((x) => (x ? [x] : []));
}
